import { render, staticRenderFns } from "./rightsDescEdit.vue?vue&type=template&id=5f300191&"
import script from "./rightsDescEdit.vue?vue&type=script&lang=js&"
export * from "./rightsDescEdit.vue?vue&type=script&lang=js&"
import style0 from "./rightsDescEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports